import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-stone-50 text-stone-900 antialiased" data-id="element-0" data-mp="28tw44o8wqe1v">
      <MetaPixel data-id="element-1" data-mp="28s2ynca15zvg" />
      <CountdownBar data-id="element-2" data-mp="23vkuadim43jn" />
      <main data-id="element-3" data-mp="23w4c7u89irxo">
        <Hero data-id="element-4" data-mp="23ujmchww7x65" />
        <StatsBar data-id="element-5" data-mp="23v2r0wxj8p28" />
        <Difference data-id="element-6" data-mp="23ti864kkyuk7" />
        <Recognize data-id="element-7" data-mp="3ik7eyd5x05p2" />
        <WhatsInside data-id="element-8" data-mp="3ikqytzf4l45q" />
        <LookInside data-id="element-9" data-mp="3ijfx0558q6h9" />
        <InstantAccess data-id="element-10" data-mp="3ihv048vgebg8" />
        <Bonuses data-id="element-11" data-mp="3mlawd43m29se" />
        <Offer data-id="element-12" data-mp="3mkrd9k285fcs" />
        <Guarantee data-id="element-13" data-mp="3mkhou0wtvg97" />
        <Testimonials data-id="element-14" data-mp="3mjq1fdddwou0" />
        <Faq data-id="element-15" data-mp="3mj6k9yvk64h1" />
      </main>
      <Footer data-id="element-16" data-mp="3rbrakqf99zft" />
    </div>;
}